import 'PublicPath';

import createStore from 'store/main';
import renderReact from 'utils/renderReact';

import App from './App';

export default renderReact('main', App, createStore);
